import { Outlet } from 'react-router'

function SportsSearchLayout() {
  return <Outlet />
}

export default SportsSearchLayout
